// src/services/worktablesService.js
import { fetchWithAuth } from "../utils/fetchWithAuth"; // ajusta la ruta si tu utils está en otra carpeta

export async function listWorktables(q) {
  const url = q ? `/worktables?q=${encodeURIComponent(q)}` : `/worktables`;
  const r = await fetchWithAuth(url);
  if (!r.ok) throw new Error(await r.text());
  return r.json();
}

export async function createWorktable(payload) {
  const r = await fetchWithAuth(`/worktables`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  });
  if (!r.ok) throw new Error(await r.text());
  return r.json();
}

export async function getWorktable(id) {
  const r = await fetchWithAuth(`/worktables/${id}`);
  if (!r.ok) throw new Error(await r.text());
  return r.json();
}

export async function updateWorktable(id, payload) {
  const r = await fetchWithAuth(`/worktables/${id}`, {
    method: "PATCH",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  });
  if (!r.ok) throw new Error(await r.text());
  return r.json();
}

export async function deleteWorktable(id) {
  const r = await fetchWithAuth(`/worktables/${id}`, { method: "DELETE" });
  if (!r.ok) throw new Error(await r.text());
  return r.json();
}

/* ---------- Minutas ---------- */
export async function listWorktableMinutes(id) {
  const r = await fetchWithAuth(`/worktables/${id}/minutas`);
  if (!r.ok) throw new Error(await r.text());
  return r.json();
}

export async function uploadWorktableMinute(id, file, opts = {}) {
  const form = new FormData();
  if (!file) throw new Error("Archivo PDF requerido");
  form.append("file", file);

  // Aceptar title o fileName; enviar SIEMPRE como fileName
  const fileName = opts.fileName ?? opts.title;
  if (fileName) form.append("fileName", fileName);
  if (opts.meetingDate) form.append("meetingDate", opts.meetingDate);

  const r = await fetchWithAuth(`/worktables/${id}/minutas`, {
    method: "POST",
    body: form,
  });
  if (!r.ok) throw new Error(await r.text());
  return r.json();
}

export async function deleteWorktableMinute(id, minuteId) {
  const r = await fetchWithAuth(`/worktables/${id}/minutas/${minuteId}`, {
    method: "DELETE",
  });
  if (!r.ok) throw new Error(await r.text());
  return r.json();
}

/** PATCH (JSON) — metadatos { fileName?, meetingDate? } */
export async function updateWorktableMinuteMeta(id, minuteId, payload) {
  // soporte alias 'title' -> 'fileName'
  const meta = {
    ...(payload.fileName != null ? { fileName: payload.fileName } : {}),
    ...(payload.title != null ? { fileName: payload.title } : {}),
    ...(payload.meetingDate != null ? { meetingDate: payload.meetingDate } : {}),
    ...(payload.date != null ? { meetingDate: payload.date } : {}),
  };

  const r = await fetchWithAuth(`/worktables/${id}/minutas/${minuteId}`, {
    method: "PATCH",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(meta),
  });
  if (!r.ok) throw new Error(await r.text());
  return r.json();
}

/** Editar minuta con reemplazo de PDF (meta + archivo con fallback) */
export async function updateWorktableMinute(id, minuteId, payload = {}) {
  const wid = encodeURIComponent(id);
  const mid = encodeURIComponent(minuteId);

  // 1) Metadatos primero (si vienen)
  const meta = {};
  if ("fileName" in payload || "title" in payload) {
    meta.fileName = payload.fileName ?? payload.title ?? "";
  }
  if ("meetingDate" in payload || "date" in payload) {
    meta.meetingDate = payload.meetingDate ?? payload.date ?? "";
  }
  if (Object.keys(meta).length) {
    const r = await fetchWithAuth(`/worktables/${wid}/minutas/${mid}`, {
      method: "PATCH",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(meta),
    });
    if (!r.ok) throw new Error(await r.text());
  }

  // 2) Reemplazo de archivo (opcional)
  if (payload.file) {
    const fd = new FormData();
    fd.append("file", payload.file);
    if (meta.fileName) fd.append("fileName", meta.fileName);
    if (meta.meetingDate) fd.append("meetingDate", meta.meetingDate);

    // 2a) intentar endpoint dedicado
    let r = await fetchWithAuth(`/worktables/${wid}/minutas/${mid}/file`, {
      method: "PATCH",
      body: fd,
    });

    // 2b) fallback a endpoint combinado (mismo path sin /file)
    if (r.status === 404) {
      r = await fetchWithAuth(`/worktables/${wid}/minutas/${mid}`, {
        method: "PATCH",
        body: fd,
      });
    }
    if (!r.ok) throw new Error(await r.text());
  }

  return true;
}

export default {
  listWorktables,
  createWorktable,
  deleteWorktable,
  getWorktable,
  updateWorktable,
  listWorktableMinutes,
  uploadWorktableMinute,
  deleteWorktableMinute,
  updateWorktableMinuteMeta,
  updateWorktableMinute,
};
